<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="py-10">
        <div class="text-center">
          <a href="/">
            <v-img
              class="m-auto mb-20"
              max-width="165"
              width="165"
              max-height="50"
              src="https://cdn.kyano.app/img/kyano-logo-dark.svg"
            ></v-img>
          </a>

          <v-img
            src="../assets/illustrations/404.svg"
            width="500"
            class="m-auto"
          ></v-img>
          <h1 class=" display-4 text-weight-bold text-primary">404</h1>
          <p>Helaas hebben deze omgeving niet kunnen vinden.</p>
          <v-btn href="/" elevation="0" color="primary" class="ma-4"
            >Naar de dashboard</v-btn
          >
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {};
</script>

<style>
</style>